module.exports = "https://static.cdns.space/classicbook-temp-tx/img/4-1.cf42b44e.jpg";